import { createFileRoute, redirect } from "@tanstack/react-router";

/** Links to removed legacy views. */
export const Route = createFileRoute("/views/$")({
	beforeLoad: () => {
		throw redirect({ to: "/", replace: true });
	},
});
